import { useState, useRef } from "react";
import { Card, CardBody, CardText, Form, Row, Col } from "reactstrap";
// moment
import moment from "moment";
// drop
import Dropzone from "react-dropzone";
// componentes
import ModeloUpload from "../../../assets/statics/modelo_estoque_atualizar.xlsx";
import ModalExcelRows from "../Voo/ModalExcelRows";
// utils
import readXlsxFile from "read-excel-file";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// validadores
import {
  allExcelColumnsUpdate,
  findRowsWithError,
  getValidStocks,
  excelColumnsPtBrUpdate,
  getValidsGroups,
  formatGroups,
} from "./ImportValidation";
// service
import { updateStockActivity } from "../../../utils/services/schedulingAndStock";

export default function ImportUpdateStock(props) {
  const { toggleModal, idEvent, refetch, jwt } = props;
  // arquivos selecionados e envio
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // erros e alerta
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  const [imgError, setImgError] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  // importando
  const importActivated = useRef(false);

  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;

    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      "ID do Estoque": {
        prop: "id",
        type: String,
      },
      Sala: {
        prop: "room",
        type: String,
      },
      Atividade: {
        prop: "task",
        type: String,
      },
      "Data e Hora Inicio": {
        prop: "initialDate",
        type: Date,
        parse(value) {
          return moment(value, "DD/MM/YYYY, HH:mm")
            .subtract(3, "hours")
            .toDate();
        },
      },
      "Data e Hora Fim": {
        prop: "endDate",
        type: Date,
        parse(value) {
          return moment(value, "DD/MM/YYYY, HH:mm")
            .subtract(3, "hours")
            .toDate();
        },
      },
      "Quantidade Máxima": {
        prop: "maxQuantity",
        type: Number,
      },
      Tipo: {
        prop: "tipo",
        type: String,
      },
      "Segregar Por Grupos": {
        prop: "segragate",
        type: String,
      },
      "Grupos e Quantidades": {
        prop: "groups",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      try {
        setImgError("");

        const { rows } = await readXlsxFile(selectedFiles[0], { schema });
        const validateRows = rows.map((row, i) =>
          allExcelColumnsUpdate(row, i),
        );
        // validar colunas se esta no padrão
        const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
        const header = rowsWithoutSchema[0];
        const schemaCreate = Object.keys(schema);

        function isEqual(schema, header) {
          if (schema.length !== header.length) return false;

          return (
            schema.every((item) => header.includes(item)) &&
            header.every((item) => schema.includes(item))
          );
        }

        if (!isEqual(schemaCreate, header)) {
          setErrors([]);
          setModalErrors(true);
          return;
        }

        setTotalRows(validateRows?.length);

        // validar campos vazios
        const rowsWithError = await findRowsWithError(validateRows);

        if (rowsWithError.length > 0 || rows.length === 0) {
          setErrors(rowsWithError);
          setModalErrors(true);
          return;
        }

        // validar se todos objetos estão cadastrados para poderem ser atualizados
        const validsStocks = await getValidStocks(validateRows, jwt, idEvent);

        if (validsStocks?.length > 0) {
          setErrors(validsStocks);
          setModalErrors(true);
          return;
        }

        const invalidsGroups = await getValidsGroups(idEvent, validateRows);

        // verificar grupos
        if (invalidsGroups.length > 0) {
          setErrors(invalidsGroups);
          setModalErrors(true);
          return;
        }

        for (const row of validateRows) {
          await updateStockActivityFunc(row, validateRows.length);
        }
      } catch (error) {
        console.error("Error reading file:", error);
        setImgError("Erro ao ler o arquivo. Verifique o formato.");
      }
    };

    readXlsx();

    async function updateStockActivityFunc(row, rowsCount) {
      const groups = await formatGroups(row, idEvent);

      const dataRow = {
        room: row.room,
        activity: row.task,
        initialDate: row.initialDate,
        endDate: row.endDate,
        maxQuantity: row.maxQuantity,
        tipo: row.tipo,
        segregarPorGrupo:
          row?.segragate?.toUpperCase() === "SIM" ? true : false,
        grupos: groups,
      };

      await updateStockActivity(row.id, dataRow, jwt)
        .then((res) => {
          if (res.message === "UPDATED") {
            count++;
            setTotalSended(count);
          }

          if (count === rowsCount || (count === 2 && rowsCount === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => {
          console.error("Erro ao atualizar atividade de estoque:", error);
          toast.error(
            `Erro ao atualizar a atividade "${row.task}" (sala ${row.room}).`,
          );
        });
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBrUpdate}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            refetch();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"Os Estoques foram atualizados com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_estoque_atualizar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={f.name}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            {imgError && <p className="text-danger">{imgError}</p>}
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={uploadService}
              title="Atualizar Estoques"
            >
              Enviar Estoques
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
